import { createContext, useContext } from 'react';

/* Feature flags que habilita el back según el entorno (GET /features). Mismos nombres que helpers/features.js del back */
export const FEATURES = Object.freeze({
    SUBPROSPECTS: 'subprospects', // subusuarios: alta, múltiples padres, documentos compartidos
});

/* Por defecto todo apagado: si el endpoint falla, el front se comporta como en prod */
export const FeaturesContext = createContext({});

export const useFeature = (name) => Boolean(useContext(FeaturesContext)[name]);
